import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "@/data/site";

export const Navbar = ({ onScrollTo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    onScrollTo(href);
  };

  return (
    <>
      <header
        data-testid="navbar"
        className={`absolute top-0 left-0 w-full z-50 transition-colors duration-500 ${
          scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
        }`}
      >
        <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
          <button data-testid="logo" onClick={() => go("#top")} aria-label="Gold Media Studio">
            <img src="/logo.png" alt="Gold Media Studio" className="h-14 sm:h-16 w-auto" />
          </button>

          <nav className="hidden md:flex items-center gap-10">
            {NAV.map((n) => (
              <button
                key={n.href}
                data-testid={`nav-${n.href.replace("#", "")}`}
                onClick={() => go(n.href)}
                className="font-display text-[0.72rem] uppercase tracking-[0.22em] text-[#a1a1aa] hover:text-[#fafafa] link-underline transition-colors"
              >
                {n.label}
              </button>
            ))}
            <button data-testid="nav-cta" onClick={() => go("#kontakt")} className="btn-gold py-3 px-6">
              Projekt starten
            </button>
          </nav>

          <button
            data-testid="menu-toggle"
            className="md:hidden text-[#fafafa]"
            onClick={() => setOpen(true)}
            aria-label="Menü öffnen"
          >
            <Menu size={26} strokeWidth={1.4} />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            className="fixed inset-0 z-[60] bg-[#050505] flex flex-col"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <div className="h-20 px-6 flex items-center justify-between border-b border-white/10">
              <img src="/logo.png" alt="Gold Media Studio" className="h-8 w-auto" />
              <button data-testid="menu-close" onClick={() => setOpen(false)} aria-label="Menü schließen">
                <X size={28} strokeWidth={1.4} />
              </button>
            </div>
            <div className="flex-1 flex flex-col justify-center px-8 gap-2">
              {NAV.map((n, i) => (
                <motion.button
                  key={n.href}
                  onClick={() => go(n.href)}
                  className="text-left font-serif text-5xl py-3 text-[#fafafa] border-b border-white/5"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.1 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                >
                  {n.label}
                </motion.button>
              ))}
              <motion.button
                onClick={() => go("#kontakt")}
                className="btn-gold mt-10 justify-center"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                Projekt starten
              </motion.button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
